import {
    getCustomer,
    listCustomers
} from './queries';
import {
    createCustomer,
    deleteCustomer,
    purgeCustomer,
    updateCustomer,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    Customer,
    CreateCustomer,
    DeleteCustomer,
    GetCustomer,
    ListCustomers,
    UpdateCustomer
} from "../types.ts";
import {
    notifyError,
    notifySuccess
} from "../../../components/PlatformNotification";
import { billingApiClient } from "../../billing-api-integration";
import {moduleConfig} from "../config";
import {ListRecordsQuery} from "../../../types";


const client = billingApiClient;


export const fetchRecords = async (query: ListRecordsQuery & { statusFilter?: string | null }) => {
    try {
        const filter = query.statusFilter ? { status: query.statusFilter } : undefined;
        
        const response = await client.graphql<GraphQLQuery<ListCustomers>>(
            {
                query: listCustomers,
                variables: {
                    ...query,
                    filter
                },
            });

        return {
            items: response.data?.listCustomers.items,
            nextToken: response.data?.listCustomers.nextToken,
        };

    } catch (e: any) {
        console.trace(e);
        if (typeof e !== 'undefined' && typeof e.errors !== 'undefined') {
            const unauthorizedExceptionFound = e.errors.find((item: {
                errorType: string,
                message: string
            }) => item.errorType === 'UnauthorizedException')
            if (unauthorizedExceptionFound) {
                window.location.href = '/'
            }
        }
        notifyError(e)
    }
};

export const fetch = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<GetCustomer>>(
            {
                query: getCustomer,
                variables: {id: id},
            });
        return response.data?.getCustomer;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const add = async (payload: any) => {
    const cleanPayload = {
        ...payload,
        contactInfo: payload.contactInfo ? {
            ...payload.contactInfo,
            phone: payload.contactInfo.phone || null,
            website: payload.contactInfo.website || null
        } : payload.contactInfo
    };

    try {
        const response = await client.graphql<GraphQLQuery<CreateCustomer>>(
            {
                query: createCustomer,
                variables: {input: cleanPayload},
            });
        console.debug('in the service response', response);
        notifySuccess(`${moduleConfig.titles.singular} created`)
        return response.data?.createCustomer;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const update = async (id: string, record: Customer) => {

    console.debug('IN UPDATE', id, record);

    const {
        createdByUsername,
        createdByUser,
        created,
        updated,
        ...rest
    } = record

    const cleanRest = {
        ...rest,
        contactInfo: rest.contactInfo ? {
            ...rest.contactInfo,
            phone: rest.contactInfo.phone || null,
            website: rest.contactInfo.website || null
        } : rest.contactInfo
    };

    try {
        const response = await client.graphql<GraphQLQuery<UpdateCustomer>>(
            {
                query: (updateCustomer),
                variables: {input: cleanRest},
            });
        notifySuccess(`${moduleConfig.titles.singular} updated`)
        return response.data?.updateCustomer;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const purgeRecord = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<DeleteCustomer>>({
            query: purgeCustomer,
            variables: {input: {id: id}},
        });
        notifySuccess(`${moduleConfig.titles.singular} purged`);
        return response.data?.deleteCustomer;
    } catch (e) {
        console.trace(e);
        notifyError(e);
    }
};

export const archiveRecord = async (id: string) => {
    try {
        const customer = await fetch(id);
        if (customer) {
            const updatedCustomer = {
                ...customer,
                status: 'ARCHIVED' as const
            };
            const response = await update(id, updatedCustomer);
            notifySuccess(`${moduleConfig.titles.singular} archived`);
            return response;
        }
    } catch (e) {
        console.trace(e);
        notifyError(e);
    }
};

export const deleteRecord = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<DeleteCustomer>>(
            {
                query: (deleteCustomer),
                variables: {input: {id: id}},

            });
        notifySuccess(`${moduleConfig.titles.singular} deleted`)
        return response.data?.deleteCustomer;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};
